const presenters = new Map();
export function registerSettlementPresenter(slug, presenter) {
    presenters.set(slug, presenter);
}
/** The presenter of the system that settled the order, when one is registered. */
export function settlementPresenter(order) {
    return order.settled_by ? presenters.get(order.settled_by) : undefined;
}
/** Filter options of the registered providers the tenant has enabled (`integrations` = the `/load` feature-gate map). */
export function settlementFilterOptions(integrations) {
    return Array.from(presenters.entries())
        .filter(([slug]) => integrations[slug])
        .map(([, presenter]) => presenter.filterOption());
}
//# sourceMappingURL=SettlementPresenter.js.map